import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getProductPreRequisite, getProductPreRequisitePending, getProductPreRequisiteError } from "../../reducer/productPreRequisiteReducer";
import { fetchProductPreRequisiteByParentProductId, fetchProductPreRequisiteByParentProduct, fetchProductDetailsByPartyId } from "../../services/fetchLearnerDashboard.service";
import { LoginService } from "../../services/login.service";
import { CourserAndModuleService } from "../../services/courseAndModule.service";
import ReactTable from "react-table";
import "react-table/react-table.css";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { AssessmentReport } from "../../services/fetchAssessmentReport";
import ciellogo from '../../assets/images/ciel-logo.png';
import CielSignature from '../../assets/images/ciel-sign.png';
import { RegisterUserService } from "../../services/registration.service"
import { success, successNotification, error, errorNotification, warning, warningNotification } from "../notification/notifications";
import { Warning } from "@material-ui/icons";
import { ProductService } from "../../services/product.service";
import { PopUpPortal } from "../../containers/popups/PopUpPortal"

class MyFinalStatus extends React.Component {
    constructor(props) {
        super(props);
        //console.log("My Status", props);

        let selectedprod = [];
        let prodid = []
        this.state = {
            finalStatus: [],
            finalStatus1:[{
                productName : "",
                attemptNumberScore:"",
                attemptNumberGrade:"",
                attemptNumberReportURL:"",
                moduleEndDate:"",
                productID :""
            }],
            data: []
        }


        if (props.preRequisite.length > 0) {
            for (let index = 0; index < props.preRequisite.length; index++) {
                const ele = props.preRequisite[index];

                if (props.mappedproductdetails != null) {
                    props.mappedproductdetails.forEach(element => {
                        let ispresent = false;
                        if (ele.seqProductID === element.productEntity.productID) {
                            if (prodid.length > 0) {
                                ispresent = prodid.includes(element.productEntity.productID);
                            }
                            prodid.push(element.productEntity.productID);

                            if (!ispresent) {
                                selectedprod.push(element);
                                return;
                            }
                        }
                    });
                }
            }
        }


        this.state = {
            finalStatus: selectedprod
        }
        let productIDs = [];
        
        if(props.mappedproductdetails && props.mappedproductdetails.length >0){
            props.mappedproductdetails.map((item)=>{
                productIDs.push(item.productEntity.productID);
              return null;
            })
          }
        let data = {
            productIDs : this.props.courseProductIDList ? this.props.courseProductIDList : productIDs ,
            emailID:this.props.emailID || localStorage.getItem("eMail"),
        }
        this.setState({loading:true})
        ProductService.getStudentProgress(data,(res)=>{
            if(res.status === 'success'){
                const updatedFinalStatus = res.responseListObject
                .filter((item) => this.state.finalStatus.some((status) => status.productEntity.productID === item.productID))
                .map((data) => ({
                  productName: data.productName,
                  attemptNumberScore: data.percentage,
                  attemptNumberGrade: data.learningStatus,
                  attemptNumberReportURL: data.downloadReport,
                  moduleEndDate: data.learningCompletionDate,
                  productID:data.productID,
                }));
                this.state.finalStatus.forEach((status) => {
                    if (!res.responseListObject.some((data) => data.productID === status.productEntity.productID)) {
                      updatedFinalStatus.push({
                        productName: status.productEntity.productName,
                        attemptNumberScore: '',
                        attemptNumberGrade: '',
                        attemptNumberReportURL: '',
                        moduleEndDate: '',
                        productID:status.productEntity.productID
                      });
                    }
                  });
              this.setState({
                finalStatus1: updatedFinalStatus,
                loading:false
              });
            }
            else{
           warning(res.reasonText,warningNotification);
           this.setState({loading:false})
            }
        })


        //console.log("My state Final Status", this.state.finalStatus);
        // }
    }

    // filterCfxReport = (emailId, productID) => {
    //     //this.props.history.push("/CfxAssessmentReport/" + emailId + "/" + productID);


    //     window.$('#progressBarPopup').modal('show')
    // };

    filterCfxReport(emailId, productID) {
        LoginService.TokenUser(res => {

            localStorage.setItem("jwt-token", res.responseObject);
            //let params = "emailid=dapsachin@test.com" //this.props.match.params.id
            let params = "emailid=" + emailId;
            params += "&productid=" + productID // this.props.match.params.prodid //"&productid=1"; //

            let cfxDataArray = [];
            AssessmentReport.fetchCfxAssessmentReport(params, res => {
                console.log(res);
                if (res.reasonText !== "Record not found") {


                    res.responseListObject.forEach(element => {
                        let cfxData = {
                            learnerReportId: element.learnerReportId,
                            learneremailid: element.emailid,
                            learnerlearningid: element.learningid,
                            learnerlearningName: element.learningName,
                            learnerlearningProgress: element.learningProgress,
                            //  learnerlearningCompletionDate: element.learningCompletionDate != null ? moment(element.learningCompletionDate).format("DD-MM-YYYY") : "",
                            learnerlearningStatus: element.learningStatus,
                            learnerlearningType: element.learningType,
                            learnerproductid: element.productid,
                            learnernode: JSON.parse(element.node),
                        }
                        cfxDataArray.push(cfxData);
                    });
                    this.setState({ data: cfxDataArray });
                    window.$('#progressBarPopup').modal('show')
                } else {
                    warning(res.reasonText, warningNotification);
                }
            }, error => {
                console.log(error);
            })

        });

    }

    downloadAsCertificate = () => {
        var data1 = localStorage.getItem("PersonnelData")
        //  console.log(JSON.parse(data).responseObject.learnerID)
        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var d = new Date();
        var monthName = months[d.getMonth()];

        let data = {
            "firstName": JSON.parse(data1).responseObject.firstName,
            "lastName": JSON.parse(data1).responseObject.lastName,
            "year": d.getFullYear(),
            "month": monthName,
            "examType": "NISM VA Preparatory Course",
            "partyId": JSON.parse(data1).responseObject.learnerID,

        }

        RegisterUserService.certificateDownload(data, res => {
            if (res.status == "success") {
                window.location.href = res.responseObject.file
                window.$('#progressBarPopup').modal('hide')
            } else {
                warning("No certificate available", warningNotification)
            }



        })
    }




    downloadAsPdf = () => {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "landscape"; // portrait or landscape

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);
        let modifiedData = [];
        const title = "";
        var Pdata = localStorage.getItem("PersonnelData")
        console.log(JSON.parse(Pdata).responseObject.firstName)
        // var imgData = 'data:image/jpeg;base64,/9j/4AAQSkZJ......';
        let t1 = "This certificate is awaited to" + " " + JSON.parse(Pdata).responseObject.firstName + " " + JSON.parse(Pdata).responseObject.lastName + " " + "for successfully completing the NISM Training"
        doc.addImage(ciellogo, 'JPEG', 310, 10);
        //  doc.text('CIEL LOGO', 380, 50);
        doc.setFontSize(12)
        doc.setFontSize(10)
        doc.text('Company Slogan', 380, 80);
        doc.setFontSize(12)
        doc.text(t1, 400, 100, 'center');
        doc.text('NISM VA content node 90%', 400, 130, 'center');
        doc.text('CIEL Signatory', 800, 400, 'right');
        //  doc.setFontSize(10);
        // const headers = [[ "Sr. No.", " Registration Date","Current Stage","First Name", "Last Name","PAN No","Next Stage","Profile Status"]];
        const headers = []
        let nextStage = ""
        this.state.data[0].learnernode.forEach((e, index) => {





            modifiedData.push([
                e.nodeName,
                e.score,
                e.nodeStatus
            ])

        });

        let content = {
            startY: 150,
            head: headers,
            body: modifiedData
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("ScoreCard.pdf")
    }

    courseReAttempt = (props) => {

        console.log(props);
    }

    render() {
     //  alert()
        var Pdata = localStorage.getItem("PersonnelData")
        let flag = true
        this.state.data && this.state.data[0].learnernode.map((e, index) => {
            if (e.nodeStatus !== "Completed") {
                flag = true
            }


        })
        // console.log(JSON.parse(data).responseObject.learnerID)
        return (
            <React.Fragment >
                {this.state.loading&&     
                <PopUpPortal
                HidePopup={this.state.loading}
                IsVisible={this.state.loading}
                />
              }
                <div className="">
                    <div className="qc" id="finalStatus">
                        <div class="mt-10">
                            {this.state.finalStatus1 ?
                                <ReactTable
                                    minRows={2}
                                    data={this.state.finalStatus1}
                                    className="-striped -highlight"
                                    defaultFilterMethod={this.filterCaseInsensitive}
                                    // columns={[
                                    //     {
                                    //         Header: "Course Name",
                                    //         id: "productName",
                                    //         accessor: d => d.productEntity.productName
                                    //     },
                                    //     // {
                                    //     //     Header: "CGPA / Percentage",
                                    //     //     id: "attemptNumberScore",
                                    //     //     accessor: d => d.attemptNumberScore
                                    //     // },
                                    //     {
                                    //         Header: "Status",
                                    //         id: "isAssessmentGrade",
                                    //         Cell: props => {
                                    //             //console.log("Attempted :" + props["original"].attemptNumberGrade)
                                    //             return (
                                    //                 props["original"].attemptNumberGrade === undefined ?
                                    //                     props["original"].isScoreUpdated >= 1 ? "Completed" :
                                    //                         'Awaiting' : props["original"].attemptNumberGrade
                                    //             );
                                    //         }
                                    //     },

                                    //     // {
                                    //     //     Header: "Payment ID",
                                    //     //     id: "paymentID",
                                    //     //     accessor: d => d.paymentID
                                    //     // },
                                    //     {
                                    //         Header: "Download Report",
                                    //         id: "attemptNumberReportURL",
                                    //         // accessor: d => d.attemptNumberReportURL,
                                    //         Cell: props => {
                                    //             console.log("URL :" + props["original"])
                                    //             return (

                                    //                 props["original"].productEntity.productID !== 203401 ?
                                    //                     props["original"].attemptNumberGrade === 'Completed' ?
                                    //                         //props["original"].isScoreUpdated >= 1 ? 
                                    //                         // <a
                                    //                         //     onClick={() => {
                                    //                         //         this.filterCfxReport(
                                    //                         //             JSON.parse(localStorage.login).emailId,
                                    //                         //             props["original"].productEntity.productID
                                    //                         //         );
                                    //                         //     }}
                                    //                         //     target="_blank"
                                    //                         //     className="download"
                                    //                         // >
                                    //                         //     Download{" "}
                                    //                         // </a>
                                    //                         ''
                                    //                         : '' :

                                    //                     props["original"].productEntity.productID === 203401 ?
                                    //                         props["original"].attemptNumberGrade === 'Initiate' ?
                                    //                             <a
                                    //                                 onClick={() => {
                                    //                                     this.filterCfxReport(
                                    //                                         JSON.parse(localStorage.login).emailId,
                                    //                                         props["original"].productEntity.productID
                                    //                                     );
                                    //                                 }}
                                    //                                 target="_blank"
                                    //                                 className="download"
                                    //                             >
                                    //                                 Download{" "}
                                    //                             </a>
                                    //                             : '' : ''

                                    //             )
                                    //             // return (
                                    //             //     props["original"].attemptNumberGrade === undefined ?
                                    //             //         props["original"].isScoreUpdated >= 0 ?
                                    //             //             props["original"].productEntity.productID === 1 ?
                                    //             //                 <a
                                    //             //                     onClick={() => {
                                    //             //                         this.filterCfxReport(
                                    //             //                             JSON.parse(localStorage.login).emailId,
                                    //             //                             props["original"].productEntity.productID
                                    //             //                         );
                                    //             //                     }}
                                    //             //                     target="_blank"
                                    //             //                     className="download"
                                    //             //                 >
                                    //             //                     Download{" "}
                                    //             //                 </a> :
                                    //             //                 props["original"].attemptNumberReportURL !== undefined ?
                                    //             //                     <a
                                    //             //                         href={props["original"].attemptNumberReportURL === '' ? '#' : props["original"].attemptNumberReportURL}
                                    //             //                         target='_blank'
                                    //             //                         class="mar-left"
                                    //             //                     > Download Report </a> : 'Report Awaited' : '' : ''
                                    //             // );
                                    //         }
                                    //     },
                                    //     // {
                                    //     //     Header: "Module End Date",
                                    //     //     id: "module_end_date",
                                    //     //     accessor: d => d.module_end_date
                                    //     // },
                                    //     // {
                                    //     //     Header: "Re-Attempt",
                                    //     //     id: "module_Re_attempt",
                                    //     //     Cell: props => {
                                    //     //         return (
                                    //     //             props["original"].isReattemptAvailable !== undefined ? props["original"].isReattemptAvailable === 1 ?
                                    //     //                 <a
                                    //     //                     onClick={() => {
                                    //     //                         this.courseReAttempt(
                                    //     //                             props["original"]
                                    //     //                         );
                                    //     //                     }}
                                    //     //                 >
                                    //     //                     Re-Attempt{" "}
                                    //     //                 </a> : '' : ''
                                    //     //         )
                                    //     //     }
                                    //     // }
                                    // ]}
                                    columns={[
                                        {
                                            Header: "Product Name",
                                            id: "productName",
                                            accessor: d => d.productName
                                        },
                                        {
                                            Header: "CGPA / Percentage",
                                            id: "attemptNumberScore",
                                            accessor: d => d.attemptNumberScore
                                        },
                                        {
                                            Header: "Status",
                                            id: "isAssessmentGrade",
                                            accessor:d => d.attemptNumberGrade
                                        },
                                        {
                                            Header: "Download Report",
                                            id: "attemptNumberReportURL",
                                            accessor: d => d.attemptNumberReportURL,
                                            Cell:props =>{
                                                console.log('props',props.original);
                                                return(
                                                    ["",undefined,null].includes(
                                                        props["original"].attemptNumberReportURL) ?
                                                  <a href className="download-link">#</a> 
                                                  :
                                                  <a 
                                                  href = {props["original"].attemptNumberReportURL} 
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="download download-link"
                                                    download
                                                >Download Report</a>
                                                );
                                            }
                                        },
                                        {
                                            Header: "Module End Date",
                                            id: "moduleEndDate",
                                            accessor: d => d.moduleEndDate? d.moduleEndDate :"",
                                        }
                                    ]}
                                    defaultPageSize={3}
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        background: 'white',
                                        color: 'black',
                                        overfloX: "auto",
                                    }}
                                /> : null}
                        </div>
                    </div>
                    <Formik

                        initialValues={{

                            data: [{ "nodeName": "Chapter 1 Growth Mindset", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1730 }, { "nodeName": "Chapter 2 Grit and Resilience", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1731 }, { "nodeName": "Chapter 3 Communication Presentation and Networking", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1732 }, { "nodeName": "Chapter 4 Grooming", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1733 }, { "nodeName": "Chapter 5 Time Management", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1734 }, { "nodeName": "Session 1 - Investor Psychology; An Introduction - QUIZ", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1735 }, { "nodeName": "Session 2 - Investor Psychology Understanding Biases and Avoiding Pitfalls_QUIZ", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1736 }, { "nodeName": "Session 3 for Developing the RIGHT Mindset Consultative Selling_QUIZ", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1737 }, { "nodeName": "Session 4 - Risk, Return and Asset Allocation_ Quiz", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1738 }, { "nodeName": "Session 5 - Personal finance & investment planning", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1739 }],

                        }}

                        onSubmit={(fields) => {

                            var data1 = localStorage.getItem("login")
                            var data2 = localStorage.getItem("PersonnelData")


                            let data = [{
                                "userName": JSON.parse(data1).userName,
                                "userId": JSON.parse(data1).userId,
                                "emailId": JSON.parse(data1).emailId,
                                "passward": "",
                                "templateId": "1960110",
                                "mobileNumber": JSON.parse(data2).responseObject.mobileNo
                            }]
                            // reattemptSendMail(data, this.props.history, res => {
                            //   console.log(res)
                            //   // this.props.history.push("/learnerDashboard");
                            //   // window.location.reload()
                            //   // if (res.status === "success") {
                            //   //   success(
                            //   //     "Mail send successfully",
                            //   //     successNotification
                            //   //   );
                            //   //   this.props.history.push("/learnerDashboard");
                            //   //   window.location.reload()
                            //   // }
                            //   // else {
                            //   //   warning(

                            //   //     "",
                            //   //     warningNotification
                            //   //   );

                            //   // }
                            // });


                        }}

                        render={({ errors, touched, handleSubmit, setFieldValue, values }) => (
                            <React.Fragment>


                                <div class="modal hide fade" id="myModal">
                                    <div class="modal-header">
                                        <a class="close" data-dismiss="modal">×</a>
                                        <h3>Modal header</h3>
                                    </div>
                                    <div class="modal-body">
                                        <p>One fine body…</p>
                                    </div>
                                    <div class="modal-footer">
                                        <a href="#" class="btn">Close</a>
                                        <a href="#" class="btn btn-primary">Save changes</a>
                                    </div>
                                </div>
                                <div
                                    className="modal fade"
                                    id="progressBarPopup"
                                    tabindex="-1" role="dialog" aria-labelledby="modalLabel" data-keyboard="true" aria-hidden="true"
                                >
                                   
                                        <div className="modal-dialog modal-md" role="document">
                                        <Form onSubmit={handleSubmit} className="form_name">
                                            <div className="modal-content">
                                                <button
                                                    type="reset"
                                                    class="close"
                                                    aria-label="Close"
                                                    onClick={
                                                        e => {
                                                            window.$('#progressBarPopup').modal('hide')
                                                        }
                                                    }
                                                >
                                                    <span aria-hidden="true">&times;</span>
                                                </button>

                                                <section className="registration">
                                                    <div className="modal-body">
                                                        <div classNames="">
                                                            <div className="modal-head" style={{
                                                                padding: "9px 8px"
                                                            }}>
                                                                {/* <div className="" style={{ textAlign: "center" }} >
                                                                    <img src={ciellogo} className="img-responsive cielLogo" />
                                                                    <h5 style={{ color: "black" }} >Company Slogan</h5>
                                                                    <div>

                                                                    </div>
                                                                    <h5 style={{ padding: "25px 10px" }} >This certificate is awaited to{" "}
                                                                        <b style={{ color: "black", fontSize: "20px" }}>{JSON.parse(Pdata).responseObject.firstName} {" "} {JSON.parse(Pdata).responseObject.lastName}
                                                                        </b> {" "}for successfully completing the NISM training</h5>
                                                                </div> */}

                                                            </div>
                                                            <div className="">
                                                                <center>
                                                                    <h5 style={{ color: "black" }} >You can download your NISM Certifcate from here</h5>
                                                                    {/* <table id="progressstatusPopup">
                                                                        <tr>
                                        

                                                                        </tr>
                                                                        {this.state.data && this.state.data[0].learnernode.map((e, index) => {
                                                                            console.log(this.state.data)
                                                                            return (
                                                                                <tr>
                                                                                    <td>{e.nodeName}</td>
                                                                                    <td>{e.score}</td>
                                                                                    <td>{e.nodeStatus}</td>
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                      


                                                                    </table> */}

                                                                </center>
                                                                {/* <button className="btn-5 mr-10" onClick={this.downloadAsPdf}>Download Scorecard
                                                                </button> */}

                                                                {flag == true ? <div className="mt-20 text-center"><button className="btn-5" onClick={this.downloadAsCertificate}>Download Certificate  </button> </div> : ''}

                                                                {/* <div style={{ textAlign: "right", paddingTop: "15px" }}>

                                                                    <img src={CielSignature} className="img-responsive cielSign" />
                                                                    CIEL Signatory
</div> */}
                                                                < br />

                                                            </div>

                                                        </div>
                                                    </div>
                                                </section>
                                            </div>
                                            </Form>
                                        </div>
                                  
                                </div>
                            </React.Fragment>
                        )}
                    />
                </div>
            </React.Fragment >
        );
    }
}
//);
export default MyFinalStatus;
